import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { TextareaField } from '@frontend/design-system';
import { PaymentTypesFieldProps } from './use-payment-knowledge-form';

type Props = {
  fieldProps: PaymentTypesFieldProps;
};

const MAX_LENGTH = 250;

export const AcceptedPaymentTypesInput = ({ fieldProps }: Props) => {
  const { t } = useTranslation('ai-receptionist-settings');
  const valueLength = typeof fieldProps.value === 'string' ? fieldProps.value.length : 0;

  return (
    <div css={styles.container}>
      <TextareaField
        {...fieldProps}
        label=''
        placeholder={t('Type Something...')}
        maxLength={MAX_LENGTH}
        height={150}
      />
      <div css={styles.footer}>
        {valueLength} / {MAX_LENGTH}
      </div>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-xs);
  `,
  footer: css`
    display: flex;
    justify-content: flex-end;
    color: var(--fabric-color-text-muted);
    font-size: var(--fabric-font-size-sm);
  `,
};
